export default __webpack_public_path__ + "static/media/glogix-logo-white.4a0686a2.png";